if(window.location.pathname.includes("reports/vendor")){
    
    var options = {
        "columnDefs": [
            {
                "render": function(data, type, row){
                    let html = data;
                    if(html=="" || html.trim()==",") html = " New Placement "+row.id;
                    return "<a href='/placement/edit/"+row.placement_id+"'>"+html+"</a>";
                },
                "targets": 1
            },
            // {
            //     "render": function(data, type, row){
            //         if(data) return '<i class="fas fa-check"></i>';
            //         else return "";
            //     },
            //     "targets": [3, 4, 5]
            // }
        ],
        "buttons": [
            {extend:"excel", text: '<i class="fas fa-file-download"></i>'}
        ]
    };
    
    $.each($(".data-table"), function(){
        $(this).data("options", options);
    });
    
}


// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/vendor.js